import isEmpty from 'lodash-es/isEmpty';

export function useEventCore() {
    const isExpanded = ref(true);
    const loadMore = ref(false);

    const isExpandedToggle = (): void => {
        isExpanded.value = !isExpanded.value;
    };

    const loadMorePrices = (): void => {
        loadMore.value = true;
    };

    function getBestPrices<T>(prices: T[] | null): T[] {
        if (!prices) return [];
        return loadMore.value ? prices : prices.slice(0, 3);
    }

    return {
        isExpanded,
        loadMore,
        isExpandedToggle,
        loadMorePrices,
        isEmpty,
        pricesBest: getBestPrices,
        getBestPrices,
    };
}
